import type { StreamingInfoResponseDrmType } from './streamingInfoResponseDrmType';

/**
 * DRM 정보 (있는 경우)
 */
export type StreamingInfoResponseDrm = {
  licenseUrl?: string;
  type?: StreamingInfoResponseDrmType;
};
